export default __webpack_public_path__ + "static/media/banner_4.0200cbbc.jpg";